export const environment = {
  production: false,
  recaptchaSiteKey: '6LdirK4sAAAAABeY-DAU-dhqRmDKs9bo0lajEebG'
};